import { EyeDropper } from '@hendrx/icons/EyeDropper';
import { ActionIcon } from '@mantine/core';
import { useEyeDropper } from '@mantine/hooks';
import cx from 'clsx';
import { useState } from 'react';

import classes from './ColorEyeDropper.module.scss';

type ColorEyeDropperProps = {
  setColor: (color: string) => void;
  disabled?: boolean;
  size?: number;
};

export function ColorEyeDropper(props: ColorEyeDropperProps) {
  const { setColor, disabled = false, size = 30 } = props;
  const [selected, setSelected] = useState(false);
  const { open } = useEyeDropper();

  const pickColor = async () => {
    setSelected(true);
    try {
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      const openEyeDropper = (await open())!;
      setColor(openEyeDropper.sRGBHex);
      setSelected(false);
    } catch (e) {
      console.error(e);
    }
  };

  return (
    <ActionIcon
      variant="default"
      disabled={disabled}
      onClick={pickColor}
      classNames={{ root: cx(classes.eyeDropper, { [classes.selected]: selected }) }}
      style={{ '--size': `${size}px` }}
    >
      <EyeDropper />
    </ActionIcon>
  );
}
